import { $http } from "@/services/api/http";
import apiEndpoints from "@/constants/api-endpoints";
import { $admin } from "./api";

/**
 * Fetches the list of the countries
 * @param {Object} params Api query params
 * @returns {Promise} Promise containing list of the countries
 */
export const getCountries = (params) => {
  return $http.get(`/v1${apiEndpoints.countries}`, params);
};

/**
 * Fetches the list of the state of a country
 * @param {String} country Name of the country whose states are to be fetched
 * @returns {Promise} Promise containing the list of the state of a country
 */
export const getStates = (country) => {
  const statesEndpoint = `/v1${apiEndpoints.countries}/${country}`;
  return $http.get(statesEndpoint);
};

/**
 * Fetches list of roles
 * @param {Object} params Roles request query params
 * @returns {Promise} Promise containing list of roles
 */
export const getRoles = (params) => {
  return $admin.get(apiEndpoints.roles, params);
};
